import React from 'react';
import Line from '../components/Line';
import '../styles.scss';

const Skybet = () => (
    <div className="bs-gamblingCompliance bs-gamblingCompliance--short">
        <div className="bs-gamblingCompliance__message">
            <Line>Customers in the United Kingdom:</Line>
            <Line className="bs-gamblingCompliance__line--spacer">
                {`Sky Bet is licensed and regulated by the Gambling Commission
                (licence number 38718).`}
            </Line>
            <Line>All other customers:</Line>
            <Line className="bs-gamblingCompliance__line--spacer">
                Sky Bet is licensed and regulated by Alderney Gambling Control Commission
            </Line>
            <Line>
                {`© 2020 Bonne Terre Limited or its affiliated companies.
                The Sky trademarks are owned by Sky UK Limited and are used under licence.`}
            </Line>
            <Line>All rights reserved.</Line>
        </div>
    </div>
);

export default Skybet;



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/Skybet/shortGamblingCompliance.jsx